<template>
    <div :class="gridClass">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            justify: { type: String, default: undefined },
        },

        computed: {
            gridClass() {
                return {
                    grid: true,
                    [`grid--justify-${this.justify}`]: this.justify,
                }
            },
        },
    }
</script>
